import { yupResolver } from "@hookform/resolvers/yup";
import { defaultFormValues as _defaultFormValues, schema } from "./constants";
import { PaymentMethodFormValues } from "./types";
import { FormProvider, useForm } from "react-hook-form";

export interface PaymentMethodFormProviderProps {
  defaultFormValues?: Partial<PaymentMethodFormValues>;
  children?: React.ReactNode;
}
export const PaymentMethodFormProvider = ({
  defaultFormValues,
  children,
}: PaymentMethodFormProviderProps) => {
  const methods = useForm<PaymentMethodFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      ..._defaultFormValues,
      ...defaultFormValues,
    },
    resolver: yupResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
